import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/brouchour.css'
import broc from './../assest/images/projectss/brochour/photo.jpg'
import bro from './../assest/images/projectss/brochour/MB WATCH BROCHOUR.pdf'
import './../assest/style/Magazine.css'

export const Brochours = () => {
  return (
 



    <div className='brochour magazine'>
        <Container>
        <div className='col-lg-6 col-sm-12 col-md-12'>
        <img src={broc}/>
        <h3>MB WATCH BROCHOUR </h3>
        <p> M.B WATCHES " Mutli Brand of Watches" 
A specialized company dedicated to selling the finest foreign watches in Iraq.</p>
        <button> <a href={bro} download="she"> <i class="fa-solid fa-download"  style={{color: "#fff" ,fontSize:"30px", padding: "15px 15px",marginRight:"20px"}}></i> </a></button>
        </div>
       </Container>
    </div>
  )
}
   
